if (!customElements.get('eb-bundle')) {
  customElements.define(
    'eb-bundle',
    class EbBundle extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.moneyFormat = this.dataset.moneyFormat;
        this.saveLabel = this.dataset.saveLabel || 'Save';
        this.cards = Array.from(this.querySelectorAll('.eb-bundle__card'));

        try {
          this.prices = JSON.parse(this.querySelector('[data-variants]').textContent);
        } catch (error) {
          this.prices = {};
        }

        this.onClick = (event) => {
          const card = event.target.closest('.eb-bundle__card');
          if (card && !card.disabled) this.setQuantity(parseInt(card.dataset.qty, 10));
        };
        this.onDocumentChange = (event) => {
          const target = event.target;
          if (!(target instanceof Element)) return;
          if (target.matches('input[name="id"]') && target.closest(`#product-form-${this.sectionId}`)) this.render();
          else if (target.matches(`#Quantity-${this.sectionId}`)) this.render();
        };

        this.addEventListener('click', this.onClick);
        document.addEventListener('change', this.onDocumentChange);
        document.addEventListener('input', this.onDocumentChange);
        this.render();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        document.removeEventListener('change', this.onDocumentChange);
        document.removeEventListener('input', this.onDocumentChange);
      }

      get quantityInput() {
        return document.getElementById(`Quantity-${this.sectionId}`);
      }

      get variantId() {
        return document.querySelector(`#product-form-${this.sectionId} input[name="id"]`)?.value;
      }

      get unitCents() {
        const price = this.prices[this.variantId];
        return Number.isFinite(price) ? price : null;
      }

      setQuantity(quantity) {
        const input = this.quantityInput;
        if (!input || !quantity) return;
        input.value = quantity;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      render() {
        const input = this.quantityInput;
        const current = input ? parseInt(input.value, 10) || 1 : 1;
        const max = input && input.max ? parseInt(input.max, 10) : null;
        const unit = this.unitCents;
        let active = null;

        this.cards.forEach((card) => {
          const qty = parseInt(card.dataset.qty, 10);
          card.disabled = Boolean(max && qty > max);
          if (qty <= current && (!active || qty > parseInt(active.dataset.qty, 10))) active = card;

          if (unit === null) return;
          const value = parseFloat(card.dataset.value) || 0;
          const base = unit * qty;
          let off = card.dataset.kind === 'percent' ? Math.round((base * value) / 100) : Math.round(value * 100);
          off = Math.min(off, base);

          card.querySelector('[data-total]').textContent = this.formatMoney(base - off);
          const was = card.querySelector('[data-was]');
          const save = card.querySelector('[data-save]');
          was.textContent = this.formatMoney(base);
          was.hidden = off < 1;
          const each = card.querySelector('[data-each]');
          if (each) each.textContent = `${this.formatMoney(Math.floor((base - off) / qty))} ${each.dataset.eachLabel}`;
          save.hidden = off < 1;
          save.textContent =
            card.dataset.kind === 'percent'
              ? `${this.saveLabel} ${Math.round(value * 100) / 100}%`
              : `${this.saveLabel} ${this.formatMoney(off)}`;
        });

        this.cards.forEach((card) => card.setAttribute('aria-pressed', String(card === active)));
      }

      formatMoney(cents) {
        const format = this.moneyFormat;
        const placeholder = /\{\{\s*(\w+)\s*\}\}/;
        const match = format && format.match(placeholder);
        if (!match) return String(cents / 100);

        const formats = {
          amount: [2, ',', '.'],
          amount_no_decimals: [0, ',', '.'],
          amount_with_comma_separator: [2, '.', ','],
          amount_no_decimals_with_comma_separator: [0, '.', ','],
          amount_with_space_separator: [2, ' ', ','],
          amount_no_decimals_with_space_separator: [0, ' ', ','],
          amount_with_apostrophe_separator: [2, "'", '.'],
        };
        const [precision, thousands, decimal] = formats[match[1]] || formats.amount;
        const [whole, fraction] = (cents / 100).toFixed(precision).split('.');
        const grouped = whole.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);

        return format.replace(placeholder, fraction ? `${grouped}${decimal}${fraction}` : grouped);
      }
    }
  );
}
